import React, { useState } from 'react';
import { Spinner } from 'reactstrap';
import { IoCloseSharp } from "react-icons/io5";
import { IoIosPlayCircle } from "react-icons/io";
import { FaRotateRight } from "react-icons/fa6";

type IProps = {
  url?: string,
  showCancelBtn?: boolean,
  customImageStyles?: string,
  resizeMode?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
  loaderSize?: number,
  customLoaderViewStyles?: string,
  uploading?: boolean,
  errorUpload?: boolean,
  reUploadCallback?: (e: any) => void,
  imgObj?: any,
  onPressImage?: (e: any) => void,
  nameInitials?: string,
  customAvatarStyles?: string
}

const CustomImageView: React.FC<IProps> = ({
  url, customImageStyles, onPressImage, resizeMode = 'cover', reUploadCallback, imgObj, showCancelBtn,
  uploading, errorUpload, nameInitials, customAvatarStyles
}) => {
  
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  const renderLoadingOverlay = () => {
    return (
      <div className='rounded-3 position-absolute top-0 left-0 w-100 h-100 media-img-overlay text-white d-flex align-items-center justify-content-center cursor-pointer'>
        <Spinner size="md" />
      </div>
    )
  };

  const renderReupload = () => {
    if (!reUploadCallback) return;
    return (
      <div className='rounded-3 position-absolute top-0 left-0 w-100 h-100 media-img-overlay text-white d-flex align-items-center justify-content-center cursor-pointer' onClick={() => reUploadCallback(imgObj)}>
        <FaRotateRight size={20} />
      </div>
    )
  };

  const renderVideoOverlay = () => {
    return (
      <div className='rounded-3 position-absolute top-0 left-0 w-100 h-100 media-img-overlay text-white d-flex align-items-center justify-content-center cursor-pointer'>
        <IoIosPlayCircle size={23} />
      </div>
    )
  }

  if (showCancelBtn) {
    return (
      <div className={`position-relative media-img-container`}>
        <div className={`overflow-hidden rounded-3 border border-gray-700 bg-white-300 media-img-wrap ${customImageStyles ? customImageStyles : ''}`}>
          <img src={url} alt="img-url" className='w-100 h-100' style={{ objectFit: resizeMode }}  />
          {imgObj?.type?.includes('video') && !loading && !uploading && !errorUpload && renderVideoOverlay()}
          {(loading || uploading) && !errorUpload && renderLoadingOverlay()}
          {(errorUpload && !loading && !uploading) && renderReupload()}
        </div>
        <div onClick={() => {}} className='media-close position-absolute z-5 bg-danger text-white d-flex align-items-center justify-content-center cursor-pointer'>
          <IoCloseSharp size={16} />
        </div>
       
        
        
      </div>
    )
  }

  const handleLoad = () => {
    setLoading(false);
  }

  const handleError = () => {
    setError(true);
    setLoading(false);
  }

  return (
    <div className={`avatar-image ${customImageStyles ? customImageStyles : ''} ${onPressImage ? 'cursor-pointer' : ''}`} onClick={onPressImage}>
      {(loading && url) && <div className='avatar-image-overlay'><Spinner size="sm" /></div> }
      {(error || !url) ?
        <div className={`avatar-text ${customAvatarStyles ? customAvatarStyles : ''}`}>{nameInitials}</div> :
        <img
        src={url}
        className={'w-100 h-100'}
        style={{ objectFit: resizeMode }}
        onLoad={handleLoad}
        onError={handleError}
        alt='img'
        />
      }
      {imgObj?.type?.includes('video') && !loading && !uploading && !errorUpload && renderVideoOverlay()}
      {/* {(loading || uploading) && !errorUpload && renderLoadingOverlay()} */}
      {(errorUpload && !loading && !uploading) && renderReupload()}
    </div>
  );
};

export default CustomImageView;
